
export const filterByStatus = (data: any[], status: boolean) => {
  return data?.filter(item => item.status === status);
};

export const sortByPosition = (data: any[]) => {
  return data?.sort((a, b) => a.position - b.position);
};